<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: ContactForm                                           |
| Section: components                                              |
| Purpose: Handles form inputs and submission for Contact.         |
+------------------------------------------------------------------+
-->
<template>
    <div class="Contact_wrapper">
        <form @submit.prevent="submitContactForm">
            <div class="form-group">
                <label for="name">{{ $t('contactPage.form.name') }}</label>
                <input type="text" v-model="name" id="name" name="name" required>
            </div>
            <div class="form-group">
                <label for="email">{{ $t('contactPage.form.email') }}</label>
                <input type="email" v-model="email" id="email" name="email" required>
            </div>
            <div class="form-group">
                <label for="subject">{{ $t('contactPage.form.subject') }}</label>
                <input type="text" v-model="subject" id="subject" name="subject" required>
            </div>
            <div class="form-group">
                <label for="message">{{ $t('contactPage.form.message') }}</label>
                <textarea v-model="message" id="message" name="message" rows="5" required></textarea>
            </div>

            <input type="hidden" name="_gotcha" v-model="gotchaField" style="display: none !important" />

            <button type="submit" class="submit-btn" :disabled="isSubmitting">
                <img v-if="!isSubmitting" src="@/assets/icons/airplane.svg">
                <span v-if="!isSubmitting">{{ $t('contactPage.form.submit') }}</span>
                <span v-else>{{ $t('contactPage.form.submitting') }}</span>
            </button>
        </form>

        <!-- Display success or error message -->
        <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
</template>

<script>
export default {
    name: "ContactForm",
    data() {
        return {
            name: "",
            email: "",
            subject: "",
            message: "",
            gotchaField: "",
            successMessage: "",
            errorMessage: "",
            isSubmitting: false,
        }
    },
    methods: {
        async submitContactForm() {
            this.isSubmitting = true;
            try {
                const response = await fetch(`${process.env.VUE_APP_BACKEND_API_URL}/contact`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-Key': process.env.VUE_APP_API_KEY
                    },
                    body: JSON.stringify({
                        name: this.name,
                        email: this.email,
                        subject: this.subject,
                        message: this.message,
                        _gotcha: this.gotchaField
                    })
                });

                if (!response.ok) {
                    throw new Error("Verzenden mislukt");
                }

                this.successMessage = this.name
                    ? this.$t('contactPage.form.successWithName', { name: this.name.trim() })
                    : this.$t('contactPage.form.successWithoutName');
                this.errorMessage = "";
                this.clearForm();
            } catch (error) {
                this.successMessage = "";
                this.errorMessage = this.$t('contactPage.form.error');
            } finally {
                this.isSubmitting = false;
            }
        },
        clearForm() {
            this.name = "";
            this.email = "";
            this.subject = "";
            this.message = "";
        }
    },
};
</script>

<style scoped>
.Contact_wrapper {
    /* background: var(--brand-bg-1); */
    /* box-shadow: var(--shadow-card-lg); */
    /* padding: 48px; */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    width: 100%;
    /* max-width: 480px; */
    margin: auto;
}

form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
}

.form-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
}

.form-group input {
    display: flex;
    height: 56px;
    padding: 16px 24px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #DDD;
    background: #FFF;
}

textarea {
    display: flex;
    padding: 16px 24px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #DDD;
    background: #FFF;
    resize: vertical;
}

.submit-btn {
    display: flex;
    height: 51px;
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: var(--border-radius-pill);
    background: var(--brand-color-1);
    color: var(--brand-text-light);
    border: 2px solid var(--brand-color-1);
    transition: var(--transition-bounce);
    box-shadow: 0px 0px 0px 0px var(--brand-color-1);
    cursor: pointer;
    font-weight: 600;
    margin-top: 24px;
}

.submit-btn:hover {
    box-shadow: 0px 0px 0px 4px var(--brand-color-1);
    text-decoration: underline;
}

.submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    text-decoration: none;
}

@media (max-width: 860px) {
    .form-group input {
        height: auto;
    }

    .form-group input,
    textarea {
        padding: 12px 16px;
    }

    .submit-btn {
        margin-top: 0;
    }
}
</style>
